export default {
  backgroundColor: "transparent",
  padding: 0,
  margin: 0,
  minHeight: 0,
  overflow: "visible",
  whiteSpace: "nowrap",
};
